/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterDeviceRequest
 */
export interface RegisterDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    deviceType?: string;
}

export function RegisterDeviceRequestFromJSON(json: any): RegisterDeviceRequest {
    return RegisterDeviceRequestFromJSONTyped(json, false);
}

export function RegisterDeviceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterDeviceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
        'deviceType': !exists(json, 'deviceType') ? undefined : json['deviceType'],
    };
}

export function RegisterDeviceRequestToJSON(value?: RegisterDeviceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'deviceType': value.deviceType,
    };
}


